import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import IndexPage from "@/views/Index/IndexPage.vue";
import ScenicPage from "@/views/Scenic/ScenicPage.vue";
import LineListPage from "@/views/LineList/LineListPage.vue";
import ScenicDetail from "@/views/ScenicDetail/ScenicDetail.vue";
import AroundRecommend from "@/views/AroundRecommend/AroundRecommend.vue";
Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "*",
    redirect: "/",
  },
  {
    path: "/",
    name: "IndexPage",
    component: IndexPage,
  },
  {
    path: "/scenic",
    name: "scenic",
    component: ScenicPage,
  },
  {
    path: "/line-list",
    name: "line-list",
    component: LineListPage,
  },
  {
    path: "/scenic-detail",
    name: "scenic-detail",
    component: ScenicDetail,
  },
  {
    path: "/around-recommend",
    name: "around-recommend",
    component: AroundRecommend,
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
